import { useState } from 'react';
import '../../css/sections/ProjectsSection.css';
import { motion } from "framer-motion";
import { TextGenerateEffect } from "../ui/text-generate-effect";
import ProjectSwitcher from '../ui/switcher';

const CATEGORIES = [
    { id: 'projects', label: 'Coding' },
    { id: 'more', label: 'Graphic Design' },
];

function ProjectsSection() {
    const [activeCategory, setActiveCategory] = useState('projects');

    return (
        <motion.div
            id='works'
            className={`projects-container`}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0 }}
            viewport={{ once: true, amount: 0.05 }}
        >
            <div className='projects-text'>
                <div className='projects-heading'>
                    <h1>MY <span className='special-font' style={{ fontStyle: "italic" }}>PROJECTS</span></h1>
                    <TextGenerateEffect
                        words="Every Project I Deliver Reflects My Obsession With Details, Continuous Self-Improvement And Working While Others Are Sleeping."
                    />
                </div>
            </div>

            <ProjectSwitcher
                activeCategory={activeCategory}
                setActiveCategory={setActiveCategory}
                categories={CATEGORIES}
            />

            {/* ZÁLOŽKA 1 */}
            {activeCategory === 'projects' && (
                <div className='projects-sections'>
                    <div className='projects-section-one'>
                        <a href="https://ssostaai.banczik.com">
                            <div className='project-image-wrapper'>
                                <img src="/images/ssostaai.svg" alt="SSOSTA AI - AI-powered chatbot by Samuel Banczik" />
                            </div>
                        </a>
                        <p> <span>SSOSTA AI</span> - An AI-Powered OpenAI Fine-Tuned Model Conversational Chatbot That Utilizes Data Collected Via A Custom Python Web Scraping Script To Provide Instant, Accurate Answers About My High School To Prospective Students And Visitors Through Natural Language Interactions.</p>
                        {/* The Comprehensive Platform Is Built With Modest Technology, Secured, Deployed, Utilizes A Database For Chat Storage And Features Email Functionality. The Project Began With Comprehensive Graphic Design, Design Manual, Wireframing And UI/UX Prototyping. */}
                        <div>
                            <button>Website</button> <button>AI</button> <button>Fine-tuned AI model</button> <button>OpenAI API</button> <button>Next.js</button> <button>React</button> <button>MongoDB</button> <button>Resend</button> <button>Cloudflare</button> <button>Vercel</button> <button>Web scraping</button> <button>Python</button> <button>Graphic design</button> <button>Branding</button> <button>Design manual</button> <button>Wireframe</button> <button>Logo</button> <button>Figma</button>
                        </div>
                    </div>
                    <div className='projects-section-two'>
                        <div className='projects-section-two-first'>
                            <a href="https://detekcegpt.cz/">
                                <div className='project-image-wrapper'>
                                    <img src="/images/detekcegpt.svg" alt="DetekceGPT - AI-powered detection system by Samuel Banczik" />
                                </div>
                            </a>
                            <p> <span>DetekceGPT</span> - An AI-Powered B2C SaaS Platform That Detects AI-Generated Content In Pasted Text Or Uploaded Documents, Scores And Highlights Suspicious Passages, Humanizes Them, Re-Analyzes The Humanized Text And Generates Follow-Up Questions.</p>
                            <div>
                                <button>Startup</button> <button>Website</button> <button>AI</button> <button>OpenAI API</button> <button>Next.js</button> <button>React</button> <button>MongoDB</button> <button>Upstash Redis</button> <button>Clerk</button> <button>Stripe</button> <button>Cloudflare</button> <button>PostHog</button> <button>Docker</button> <button>Graphic design</button> <button>Logo</button> <button>Figma</button>
                            </div>
                        </div>
                        <div className='projects-section-two-second'>
                            <a href="https://royalsf.banczik.com">
                                <div className='project-image-wrapper'>
                                    <img src="/images/royal2.svg" alt="Royal S.F. - e-commerce platform by Samuel Banczik" />
                                </div>
                            </a>
                            <p> <span>Royal S.F.</span> - An E-Commerce Platform With Comprehensive Company Information For A Student-Run Business, Featuring A Complete Product Catalogue, Secure Online Payments And Automated Order Confirmation Emails.</p>
                            <div>
                                <button>Website</button> <button>Next.js</button> <button>React</button> <button>Stripe</button> <button>Resend</button> <button>Cloudflare</button> <button>Vercel</button> <button>Wireframe</button> <button>Figma</button>
                            </div>
                        </div>
                    </div>
                    <div className='projects-section-two'>
                        <div className='projects-section-two-first'>
                            <a href="https://heattrack-production.up.railway.app/">
                                <div className='project-image-wrapper'>
                                    <img src="/images/heattracklogo2.svg" alt="HeatTrack - AI heating analytics system by Samuel Banczik" />
                                </div>
                            </a>
                            <p> <span>HeatTrack</span> - An Intelligent System Utilizes Sensors And A Web Application To Seamlessly Monitor, Predict, Analyze Indoor And Outdoor Temperatures, Heat Consumption And Overall Heating Costs. By AI Data Analysis, The System Optimizes Home Energy Management And Efficiency.</p>
                            <div>
                                <button>Website</button> <button>AI</button> <button>OpenAI API</button> <button>PHP</button> <button>JS</button> <button>HTML</button> <button>CSS</button> <button>MySQL</button> <button>Railway</button> <button>Graphic design</button> <button>Wireframe</button> <button>Logo</button> <button>Figma</button> <button>Adobe Illustrator</button>
                            </div>
                        </div>
                        <div className='projects-section-two-second'>
                            <a href="https://findmefont.banczik.com">
                                <div className='project-image-wrapper'>
                                    <img src="/images/findmefont.svg" alt="FindMeFont - AI font discovery SaaS by Samuel Banczik" />
                                </div>
                            </a>
                            <p> <span>FindMeFont</span> - An AI-Powered B2C SaaS Platform Helping Creators Find The Right Font In Seconds By Matching The Intent Behind Their Text With The Perfect Typography.</p>
                            <div>
                                <button>Startup</button> <button>Website</button> <button>AI</button> <button>OpenAI API</button> <button>Next.js</button> <button>React</button> <button>MongoDB</button> <button>Upstash Redis</button> <button>Clerk</button> <button>Stripe</button> <button>Resend</button> <button>Cloudflare</button> <button>Vercel</button> <button>Graphic design</button> <button>Wireframe</button> <button>Logo</button> <button>Figma</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ZÁLOŽKA 2 */}
            {activeCategory === 'more' && (
                <div className='projects-sections'>
                    <div className='projects-section-one'>
                        <a href="/ssostasnackbar">
                            <div className='project-image-wrapper'>
                                <img src="/images/snackbar.svg" alt="SSOSTA Snackbar - branding and visual identity by Samuel Banczik" />
                            </div>
                        </a>
                        <p> <span>SSOSTA Snackbar</span> - Complete Visual Identity Including Branding, Graphic Design, Photography And Marketing Materials For A School Cafeteria. Acquired Instagram 31 000+ Monthly View.</p>
                        <div>
                            <button>Graphic design</button> <button>Instagram posts</button> <button>Branding</button> <button>Figma</button> <button>Photography</button> <button>Photo editing</button> <button>Adobe Lightroom</button>
                        </div>
                    </div>
                    <div className='projects-section-two'>
                        <div className='projects-section-two-first'>
                            <a href="/ssostaai">
                                <div className='project-image-wrapper'>
                                    <img src="/images/ssostaai2.svg" alt="SSOSTA AI product launch video - creative direction by Samuel Banczik" />
                                </div>
                            </a>
                            <p> <span>SSOSTA AI</span> - A Cinematic Product Launch Video Showcasing The Platform With Creative Direction, Visual Storytelling And Professional Production To Captivate Prospective Users And Investors.</p>
                            <div>
                                <button>Product launch video</button> <button>Creative direction</button> <button>Video production</button> <button>Commercial</button> <button>Jitter video</button>
                            </div>
                        </div>
                        <div className='projects-section-two-second'>
                            <a href="/graduation">
                                <div className='project-image-wrapper'>
                                    {/* <img src="/images/zasadaciporiadok.png" alt="" /> */}
                                    <img className='graduation-card-image' src="/images/oznamko.png" alt="Graduation announcement card - graphic design by Samuel Banczik" />
                                </div>
                            </a>
                            <p> <span>Graduation</span> - A Graphic Identity For My High School Graduation, Including Announcement Cards, Name Cards And A Seating Plan.</p>
                            <div>
                                <button>Graphic design</button> <button>Branding</button> <button>Print design</button> <button>Figma</button>
                            </div>
                        </div>
                    </div>
                    <div className='projects-section-two'>
                        <div className='projects-section-two-first'>
                            <a href="/pawsie">
                                <div className='project-image-wrapper'>
                                    <img className='pawsie-card-image' src="/images/doggie2.png" alt="Pawsie brand mascot - graphic design by Samuel Banczik" />
                                </div>
                            </a>
                            <p> <span>Pawsie</span> - A Complete Visual Identity For A Pet Sitting Platform That Connects Pet Owners With People Who Want To Walk And Look After Their Animals And Brings Shelters Together, Including A Trifold Flyer, A Set Of Instagram Posts And An Illustrated Brand Mascot.</p>
                            <div>
                                <button>Graphic design</button> <button>Branding</button> <button>Instagram posts</button> <button>Print design</button> <button>Mascot</button> <button>Figma</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </motion.div>
    );
}

export default ProjectsSection;
